import React from 'react';
import './Loader.css';

/**
 * Custom Loader Component
 * @param {boolean} fullScreen - Whether to show the loader as a full-page overlay.
 */
const Loader = ({ fullScreen = false }) => {
    return (
        <div className={`loader-container ${fullScreen ? 'full-screen' : ''}`}>
            <div className="custom-spinner">
                <div className="ring ring-outer"></div>
                <div className="ring ring-middle"></div>
                <div className="ring ring-inner"></div>
                <div className="logo-center">
                    {/* Optional Small Logo or Icon in center if needed */}
                </div>
            </div>
        </div>
    );
};

export default Loader;
